import { Injectable } from '@angular/core';

@Injectable()
export class NumberCardsService {

  constructor() { }

  /** computes the solution, based on  the cards and the requested number 
   * @param {number} requestedNumber - number to represent
   * @param {number[]} cards - cards used to represent the number
  */
  getSolution(requestedNumber: number, cards: number[]):number[]{
    let currentCard = cards[0];
    let index = 0;
    let remainder:number = requestedNumber;
    let solution:number[] = []
    for(let i = 0; i < cards.length; i++){
      solution.push(0);
    }

    while (remainder > 0){
      if(currentCard <= remainder){
        solution[index]++;
        remainder -= currentCard;
      } else {
        index++;
        currentCard=cards[index];
      }
    }
    return solution;
  }

/**return the cards given, the type of representation 
 * @param {string} representation - holds the representation type
 * @param {any} representationSpec - holds the specification for the representation
*/
getCards(representation:string, representationSpec: any):number[]{
  let cards = [];
  switch(representation){
    case "nary": 
      let base = +representationSpec;
      let cardValue = 1;
      let cardCount = 5;
      if(base < 4){
        cardCount = 9;
      }
      for(let i = 0; i < cardCount; i++){
        cards.unshift(cardValue);
        cardValue = base * cardValue;
      }
      break;
    case "personal":
      cards = representationSpec;
      break;
    case "roman": 
      cards = [500, 100, 50, 10, 5, 1];
      break;
    case "etruscan":
      cards = [3600, 600, 60, 10, 1];
      break;
    case "hexadecimal":
      cards = [256, 16, 1];
  }
  return cards;
}

/** returns count 0 for every card
 * @param {number[]} cards - cards to return count for
 */
getCount(cards:number[]):number[]{
  let count = [];
  for (let card of cards){
    count[card] = 0;
  }
  return count;
}

/** returns value of the given representation 
 * @param {number[]} count - holds the represenation
*/
getValue(count:number[]):number{
  let result = 0;
  for(let key in count){
    result += +key * count[key];
  }
  return result;
}

getRepresentation(requested:number, represenation:string, representationSpec: any):string{
  let cards = this.getCards(represenation, representationSpec);
  let solution = this.getSolution(requested, cards);
  let result = "";
  let leading = true;
  for(let digit of solution){
    let cdigit = digit.toString();
    if(digit == 0 && leading){
      cdigit = "";
    }
    if(digit > 0){
      leading = false;
    }
    if(represenation=="hexadecimal" && digit > 9){
      cdigit = String.fromCharCode(97 + digit -10);;
    }
    result = result.concat(cdigit);
  }
  return result;
}

/** returns, whether the cards build a valid representation */
checkValidCards(cards: any):boolean{
  if (!(typeof cards == "string")) {
    return false;
  } 
  let cardArray = cards.split(",");
  let oldCard = undefined;
  for(let card of cardArray){
    if(oldCard != undefined){
      if(+oldCard % +card != 0){
        return false;
      }
    }
    oldCard=card;
  }
  if(+cards[cards.length-1] != 1){
    return false;
  }
  return true;
}

}
 